module.exports = __webpack_public_path__ + "static/media/customerHeader.12b32881.jpg";